import React, { useContext, useEffect, useState } from 'react'
import Cards from '../cards/Cards'
import './Wishlist.css'
import { CartContext } from '../cart/ContextProvider'
import Loader from '../common/Loader'

function Wishlist() {

    const { wishlist } = useContext(CartContext)
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setTimeout(() => { setLoading(false) }, 800)
    })


    return (
        <>
            {loading ? (<Loader></Loader>) : (
                <div className=''>
                    {wishlist.length === 0 ? ((
                        <div className=''  >
                            <div className='no-wish'>
                                <img src='../../assets/no-wish.png' alt='No items in wishlist' />
                            </div>
                        </div>)) : (<div className='wishlist-main'><div className='wishlist-heading'>
                            <h1>My Wishlist</h1>

                        </div>
                            <div className='wishlist-hr'>
                                <hr />
                            </div>

                            <div className='wishlist-card'>
                                {wishlist.map((shirt, id) => (
                                    <div className=''  >
                                        <Cards key={id} shirt={shirt} />
                                    </div>
                                ))}
                            </div></div>)}


                </div>)}

        </>
    )


}

export default Wishlist;